import { render, staticRenderFns } from "./AdminShippingSection.vue?vue&type=template&id=0cb13240&scoped=true"
import script from "./AdminShippingSection.vue?vue&type=script&lang=js"
export * from "./AdminShippingSection.vue?vue&type=script&lang=js"
import style0 from "./AdminShippingSection.vue?vue&type=style&index=0&id=0cb13240&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb13240",
  null
  
)

export default component.exports